import API from "../../../app/api";

export const gettransporters = async () => {
  try {
    const response = await API.get("/transporter");
    return response.data;
  } catch (error) {
    console.error("Transporter API Error:", error);
    throw error;
  }
};